"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartBody = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var Text_1 = require("../Text");
function ChartBody(props) {
    var children = props.children, width = props.width, height = props.height, caption = props.caption, rest = __rest(props, ["children", "width", "height", "caption"]);
    return (react_1.default.createElement("div", __assign({ style: { padding: '0.5rem 1rem' } }, rest),
        caption && (react_1.default.createElement(Text_1.Text, { component: 'p', style: { width: width, padding: '0 0.5rem' } }, caption)),
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: width, height: height }, children)));
}
exports.ChartBody = ChartBody;
ChartBody.defaultProps = {
    height: 700,
    width: '100%',
};
//# sourceMappingURL=ChartBody.js.map